import { Container, Typography } from '@pwskills/rachnaui';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import StyleHtml from '@/HOCs/StyleHtml';
import { useRouter } from 'next/router';
import { sanitizeDescriptionHtml } from '@/utils/GlobalCommonFunctions';
import MasterclassHeader from '../MasterclassHeader';

const CertificateSection = () => {
  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );
  const router = useRouter();
  const isDashBoard = router?.pathname.includes('/dashboard/overview');
  const certificate = masterclassDetails?.certificateType || [];
  return (
    <div className={`${isDashBoard ? '' : 'medium:bg-blue-50 h-full'} w-full`}>
      <Container
        id="category-hero-section"
        className={`${
          isDashBoard
            ? 'medium:!px-12 !pt-6 medium:!pb-6 medium:!pr-0 px-4 large:!px-8 gap-4'
            : '!py-8 medium:!py-8 large:!py-9 !px-4 medium:!px-[42px] large:!px-20'
        } flex flex-col`}
      >
        {isDashBoard && (
          <Typography component="subheading" variant="bold" className="text-gray-850">
            {certificate[0]?.name}
          </Typography>
        )}
        <div
          className={`flex flex-col medium:flex-row  items-center medium:p-6 large:py-6 large:pr-[101px] large:pl-[43px] relative  rounded-3xl ${
            !isDashBoard ? 'bg-white justify-between' : 'justify-between'
          }`}
        >
          <div
            className={`flex flex-col ${
              isDashBoard ? 'w-full' : 'medium:w-[332px] large:w-[454px]'
            } gap-6 medium:gap-8`}
          >
            <div className="flex flex-col gap-[20px] medium:gap-0 px-[28px] medium:px-0">
              {!isDashBoard && (
                <MasterclassHeader
                  headerText={certificate[0]?.name || ''}
                  className=" text-center medium:!text-start"
                />
              )}
              <img
                src={certificate[0]?.certificateImage}
                alt="certificateImage"
                className={`z-[1] ${
                  isDashBoard ? 'w-full' : 'medium:w-[200px] medium:h-[283px] large:w-[220px]'
                } large:h-[311px] block medium:!hidden shadow-dark rounded-lg`}
              />
            </div>
            <div className="hidden medium:!block">
              <StyleHtml>
                <div
                  style={{
                    wordBreak: 'break-word',
                    textJustify: 'auto',
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                    // fontSize: '14px',
                    // lineHeight: '22px',
                    textAlign: 'left',
                    color: '#3D3D3D ',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: sanitizeDescriptionHtml(certificate[0]?.description || ''),
                  }}
                />
              </StyleHtml>
            </div>
            <div className="block medium:!hidden">
              <StyleHtml>
                <div
                  style={{
                    wordBreak: 'break-word',
                    textJustify: 'auto',
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                    // fontSize: '14px',
                    // lineHeight: '22px',
                    textAlign: 'center',
                    color: '#3D3D3D ',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: sanitizeDescriptionHtml(certificate[0]?.description || ''),
                  }}
                />
              </StyleHtml>
            </div>
          </div>
          <img
            src={certificate[0]?.certificateImage}
            alt="certificateImage"
            className=" z-[1] medium:w-[200px] medium:h-[283px] large:w-[220px] large:h-[311px] hidden medium:!block shadow-dark rounded-lg"
          />

          {!isDashBoard && (
            <img
              src="/images/masterclassDescription/certificate_bg.svg"
              alt="bg"
              className="absolute bottom-0 right-0  rounded-br-3xl hidden medium:!block"
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default CertificateSection;
